import { useEffect } from 'react';
import { useRouting } from './useRouting';

export function useRouterWillLeave(
  isUnsaved: boolean,
  {
    message = 'You have unsaved changes, are you sure you want to leave?',
  } = {},
) {
  const routing = useRouting();

  useEffect(() => {
    if (!routing) return;

    const handleRouteLeave = () => {
      if (isUnsaved) {
        return message;
      }
    };

    const removeHook = routing.router.setRouteLeaveHook(
      routing.route,
      handleRouteLeave,
    );

    return () => {
      removeHook?.();
    };
  }, [routing, isUnsaved, message]);
}
